import StyledButtonClose from './styles/StyledButtonClose';
import ControlsClose from '@/external/icons/ControlsClose';

type Props = {
  handleClose: () => void;
};

const ButtonClose: FC<Props> = ({ handleClose }) => (
  <StyledButtonClose onClick={handleClose}>
    <ControlsClose fontSize={24} />
  </StyledButtonClose>
);

export default ButtonClose;
